module.exports = __webpack_public_path__ + "images/1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/slider/1.jpg
 ** module id = 645
 ** module chunks = 0
 **/